import gsap, { SplitText } from "@lib/gsap";
import { onMount, onView, onTrack, onDestroy, onPageIn, onPageOut } from "./_";
import { Scroll } from "@lib/scroll";

export default function (element, dataset) {
  element.querySelectorAll(".w-richtext p").forEach((p) => {
    if (p.textContent.trim() === "\u200D") {
      p.style.borderTop = "1px solid #DCD5CC";
    }
  });

  const tables = document.querySelectorAll("[data-table]");
  if (!tables.length) return;

  const walker = document.createTreeWalker(
    element.querySelector(".w-richtext"),
    NodeFilter.SHOW_TEXT,
    null,
  );

  const matches = [];

  while (walker.nextNode()) {
    const node = walker.currentNode;
    const match = node.textContent.match(/^\[\[table-(\d+)\]\]$/);
    if (match) {
      matches.push({ node, index: parseInt(match[1], 10) });
    }
  }

  matches.forEach(({ node, index }) => {
    const table = tables[index - 1];
    if (!table) return;
    node.parentElement.replaceWith(table);
  });

  Scroll.resize();
}
